// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7d2fcd0758c90e32","4124":"3ed6de4631b4d719"}[chunkId] + ".css";
};